import { ActionTypes } from "./Types"

export const addToCard = (product, quantity) =>({
    type: ActionTypes.ADD_CART,
    payload:{
        product,
        quantity: quantity || 1
    }
})
export const removeFromCard = (product)=>({
    type:ActionTypes.REMOVE_ITEM,
    payload:{product}
})